import { __decorate } from "tslib";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CalciteButtonComponent } from "./calcite/components/calcite-button/calcite-button.component";
import { CalciteInputComponent } from "./calcite/components/calcite-input/calcite-input.component";
import { CalciteSelectComponent } from "./calcite/components/calcite-select/calcite-select.component";
import { ReactiveFormsModule } from "@angular/forms";
import { CalciteCardComponent } from "./calcite/components/calcite-card/calcite-card.component";
import { CalciteCheckboxComponent } from "./calcite/components/calcite-checkbox/calcite-checkbox.component";
import { CalciteComboboxComponent } from "./calcite/components/calcite-combobox/calcite-combobox.component";
import { CalciteDatePickerComponent } from "./calcite/components/calcite-date-picker/calcite-date-picker.component";
import { CalciteDropdownComponent } from "./calcite/components/calcite-dropdown/calcite-dropdown.component";
import { CalciteListComponent } from "./calcite/components/calcite-list/calcite-list.component";
import { CalciteLinkComponent } from "./calcite/components/calcite-link/calcite-link.component";
import { CommonModule } from "@angular/common";
import { CalciteStepperComponent } from "./calcite/components/calcite-stepper/calcite-stepper.component";
import { RequiredClassDirective } from "./calcite/components/calcite-input/required-class.directive";
import { CalciteFormMultiselectComponent } from "./calcite/components/calcite-form-multiselect/calcite-form-multiselect.component";
export let ZaesriAngularCalciteModule = class ZaesriAngularCalciteModule {
};
ZaesriAngularCalciteModule = __decorate([
    NgModule({
        schemas: [CUSTOM_ELEMENTS_SCHEMA],
        declarations: [
            CalciteButtonComponent,
            CalciteInputComponent,
            CalciteSelectComponent,
            CalciteCardComponent,
            CalciteCheckboxComponent,
            CalciteComboboxComponent,
            CalciteDatePickerComponent,
            CalciteFormMultiselectComponent,
            CalciteDropdownComponent,
            CalciteListComponent,
            CalciteLinkComponent,
            CalciteStepperComponent,
            RequiredClassDirective
        ],
        imports: [
            ReactiveFormsModule,
            CommonModule
        ],
        exports: [
            CalciteButtonComponent,
            CalciteInputComponent,
            CalciteSelectComponent,
            CalciteCardComponent,
            CalciteCheckboxComponent,
            CalciteComboboxComponent,
            CalciteFormMultiselectComponent,
            CalciteDatePickerComponent,
            CalciteDropdownComponent,
            CalciteListComponent,
            CalciteLinkComponent,
            CalciteStepperComponent
        ],
    })
], ZaesriAngularCalciteModule);
